<template>
  <Teleport to="body">
    <div class="fixed top-0 left-0 w-full h-full text-sm">
      <div class="absolute bg-corepla-dark z-10 w-full h-full bg-opacity-50" />
      <div
        class="absolute modal-size rounded bg-white z-20 p-3 shadow-xl"
      >
        <slot />
      </div>
    </div>
  </Teleport>
</template>